import {
  stopAutoPlay,
  enablePlay,
  enableBet,
  enableCollect,
  enableCtBonusSpin,
  displayGambleBtn,
  checkUserBalToBet,
  changePlayBtnTo,
  enableWildFairiesBonusSpin,
} from "./Functions_GameBar";
import {
  Credits,
  convertCreditsFromServerToClient,
} from "../datastructures/Credits";
import { CommonData } from "../datastructures/gamestate/gameData";
// import Axios from "axios";
import { startJackpot } from "../JackpotGame/jackpotGlobalFunctions";
import { closeOptionWindow } from "./Functions_OptionWindow";
import * as jQuery from "jquery";
import { getParameterByName } from "../getParameters";
import axios from "axios";
import GameVersion from "../gameLib/Singleton/versionSingleton";

export function truncateString(string: string, limit: number) {
  if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
}
export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  const clone: any = Array.isArray(obj) ? [] : ({} as T);

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clone[key as keyof T] = deepClone(obj[key]);
    }
  }

  return clone;
}

export function replaceUnderscoresWithSpaces(inputText: string): string {
  // Use the replace() method with a regular expression to replace underscores with spaces
  const cleanedText = inputText.replace(/_/g, " ");
  return cleanedText;
}

// Example usage:
const inputText = "This_is_an_example_text_with_underscores";
const cleanedText = replaceUnderscoresWithSpaces(inputText);
console.log(cleanedText);

export function betlistFromServer(activeGameData: CommonData) {
  var stakes = activeGameData.loginResponse.gameSettings.stakes;
  activeGameData.betList = [];
  for (var i = 0; i < stakes.length; i++) {
    activeGameData.betList.push(new Credits(stakes[i]));
  }

  activeGameData.betSelected = activeGameData.betList[activeGameData.betIndex]; //-by default take the third index
}

export function reverseArr(input: any) {
  var ret = new Array();
  for (var i = input.length - 1; i >= 0; i--) {
    ret.push(input[i]);
  }
  return ret;
}
export function jsonCopy(src: any) {
  return JSON.parse(JSON.stringify(src));
}

export function isObjectEmpty(obj: Object) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}
export function onOptionButtonDownRedirectHome() {
  let homeUrl = getParameterByName("homeUrl");
  window.open(homeUrl, "_top");
}
export function onOptionButtonDownRedirectDepositPage() {
  let depositUrl = decodeURIComponent(getParameterByName("depositUrl"));
  if (depositUrl === null) {
    //link dont exist so redirect to homepage
    onOptionButtonDownRedirectHome();
  } else {
    //link exist so open in new tab
    window.open(depositUrl);
  }
}

export function onOptionButtonDownRedirectPrint(
  isBuyBonusAvailableInGame: boolean = false,
  isAutoPlayAvailableInGame: boolean = true,
  isJackpotAvailableInGame: boolean = false
) {
  // window.open("https://s3.eu-central-1.amazonaws.com/dev-greenisland-games/firecubes/help.html");
  let lang = getParameterByName("lang").toLowerCase();
  if (lang === null) {
    lang = "en";
  }

  //  additional parameters you want to attach
  let isBuyBonusAvailable = isBuyBonusAvailableInGame; //BBA for BuyVonusAvailable
  let isAutoPlayAvailable = isAutoPlayAvailableInGame; //BBA for BuyVonusAvailable
  let isJackpotAvailable = isJackpotAvailableInGame; //BBA for BuyVonusAvailable

  //--
  // if (isBuyBonusAvailable) {
  // Construct the URL for the help page with the language parameter and additional parameters
  let hash = `lang=${lang}&isBuyBonusAvailable=${isBuyBonusAvailable}&isAutoPlayAvailable=${isAutoPlayAvailable}&isJackpotAvailable=${isJackpotAvailable}`;
  console.log(hash);
  window.open(`help.html#${hash}`);
  // } else {
  //   //-default page with no extra param than langauge
  //   window.open("help.html#" + lang); //default for most games
  // }
}
export function onOptionButtonDownRedirectPrintV2(
  isJackpotAvailable: boolean = null,
  initurl: any = null
) {
  // window.open("https://s3.eu-central-1.amazonaws.com/dev-greenisland-games/firecubes/help.html");
  let lang = getParameterByName("lang").toLowerCase();

  if (lang === null) {
    lang = "en";
  }

  if (isJackpotAvailable != null) {
    let initRequestUrl = encodeURIComponent(initurl);
    window.open(
      "help.html#" +
        lang +
        "&isJackpotAvailable=" +
        isJackpotAvailable +
        "&gameSettingUrl=" +
        initRequestUrl
    ); //for the games where i can give if jackpot is available
  } else {
    window.open("help.html#" + lang); //default for most games
  }
}

export function createMovieClipTexture(
  name: string,
  start: number,
  end: number
) {
  //   let movie: PIXI.extras.AnimatedSprite;
  let frames = [];

  for (var j = start; j < end; j++) {
    if (j < 10) {
      frames.push(PIXI.Texture.fromFrame(name + "_0000" + j + ".png"));
    } else if (j >= 100) {
      frames.push(PIXI.Texture.fromFrame(name + "_00" + j + ".png"));
    } else {
      frames.push(PIXI.Texture.fromFrame(name + "_000" + j + ".png"));
    }
  }
  return frames;
}

export function createMovieClipWithXLoops(
  name: string,
  start: number,
  end: number,
  loopCount: number
) {
  let movie;
  let frames = [];

  for (let i = 0; i < loopCount; i++) {
    for (var j = start; j < end; j++) {
      if (j < 10) {
        frames.push(PIXI.Texture.fromFrame(name + "_0000" + j + ".png"));
      } else {
        frames.push(PIXI.Texture.fromFrame(name + "_000" + j + ".png"));
      }
    }
  }

  movie = new PIXI.extras.AnimatedSprite(frames);
  movie.onComplete = function() {};
  movie.animationSpeed = 0.5;
  movie.loop = false;
  movie.stop();
  return movie;
}
export function createMovieClip(name: string, start: number, end: number) {
  let frames = createMovieClipTexture(name, start, end);
  let movie: PIXI.extras.AnimatedSprite;
  movie = new PIXI.extras.AnimatedSprite(frames);
  movie.onComplete = function() {
    /*backgroundimg.removeChild(diceFallAnimmovies[0]);*/
  };
  movie.animationSpeed = 0.5; //diceSpeed
  // movie.x=size[0]/2;
  // movie.y=size[1]/2;
  movie.loop = true;

  movie.stop();
  return movie;
}
export function createMovieClipPingPong(
  name: string,
  start: number,
  end: number
) {
  let movie;
  let frames = [];

  for (var j = start; j < end; j++) {
    if (j < 10) {
      frames.push(PIXI.Texture.fromFrame(name + "0000" + j + ".png"));
    } else {
      frames.push(PIXI.Texture.fromFrame(name + "000" + j + ".png"));
    }
  }

  for (var j = end - 2; j > start; j--) {
    if (j < 10) {
      frames.push(PIXI.Texture.fromFrame(name + "0000" + j + ".png"));
    } else {
      frames.push(PIXI.Texture.fromFrame(name + "000" + j + ".png"));
    }
  }

  movie = new PIXI.extras.AnimatedSprite(frames);
  movie.onComplete = function() {
    /*backgroundimg.removeChild(diceFallAnimmovies[0]);*/
  };
  movie.animationSpeed = 0.5; //diceSpeed
  // movie.x=size[0]/2;
  // movie.y=size[1]/2;
  movie.loop = true;

  movie.stop();
  return movie;
}
export function removeDuplicates(arr: Array<any>) {
  var result = [];
  for (var i = 0; i < arr.length; i++) {
    if (result.indexOf(arr[i]) == -1) {
      result.push(arr[i]);
    }
  }
  return result;
}
export function autoRescale(
  elementToResize: PIXI.Container,
  activeGameData: CommonData,
  app: PIXI.Application
) {
  // var resolution: number = 1;

  let ratioScaleY: number;
  let ratioScaleX: number;
  let size = activeGameData.size;
  let gameResolution = activeGameData.gameResolution;
  let ratio = activeGameData.ratio;

  // let tarRes=[1920,1080];
  if (window.innerWidth / window.innerHeight >= ratio) {
    activeGameData.resolution = window.innerHeight / gameResolution[1];
  } else {
    activeGameData.resolution = window.innerWidth / gameResolution[0];
  }
  app.renderer.view.style.width = window.innerWidth + "px";
  app.renderer.view.style.height = window.innerHeight + "px";
  app.renderer.resize(
    window.innerWidth / activeGameData.resolution,
    window.innerHeight / activeGameData.resolution
  );
  if (window.innerWidth / window.innerHeight < ratio) {
    //portrait

    ratioScaleX = window.innerWidth / activeGameData.resolution / size[0];
    elementToResize.scale.x = ratioScaleX;
    elementToResize.scale.y = ratioScaleX;
    elementToResize.x =
      (window.innerWidth / activeGameData.resolution - size[0] * ratioScaleX) /
      2;
    // elementToResize.y =(window.innerHeight / activeGameData.resolution - size[1] * ratioScaleX) / 2;
    activeGameData.ratioScaleX = ratioScaleX;

    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;

    let screenRatio = window.innerHeight / window.innerWidth;

    if (
      activeGameData.playOnPortrait &&
      activeGameData.isMobile &&
      orientationPortrait &&
      activeGameData.gameLoaded &&
      screenRatio >= activeGameData.minRatioForPortraitPlay
    ) {
      //portrait mode , playable
      elementToResize.y = activeGameData.portraitPlayOffsetTop * ratioScaleX;
    } else {
      //portrait mode , non playable
      elementToResize.y =
        (window.innerHeight / activeGameData.resolution -
          size[1] * ratioScaleX) /
        2;
    }
    // elementToResize.y = (window.innerHeight / activeGameData.resolution - size[1] * ratioScaleX) / 2;
  } else {
    //landscape
    ratioScaleY = window.innerHeight / activeGameData.resolution / size[1];
    elementToResize.scale.x = ratioScaleY;
    elementToResize.scale.y = ratioScaleY;
    elementToResize.x =
      (window.innerWidth / activeGameData.resolution - size[0] * ratioScaleY) /
      2;
    elementToResize.y =
      (window.innerHeight / activeGameData.resolution - size[1] * ratioScaleY) /
      2;

    activeGameData.ratioScaleX = 1;
  }
  window.scrollTo(0, 0);
  // console.log("==>",ratioScaleY,activeGameData.resolution);
}
export function playerActivityUpdate(activeGameData: CommonData) {
  if (activeGameData.userActivityMsgDisplay) {
    stopAutoPlay(activeGameData);
    updateUseInfoText(activeGameData);
    activeGameData.playerActivityMessageBox.setMessageBoxVisibile(true, 0);
  }
}
export function updateUseInfoText(activeGameData: CommonData) {
  let totalBet = convertCreditsFromServerToClient(
    activeGameData.msgtotalBET
  ).toFixed(2);
  let totalWin = convertCreditsFromServerToClient(
    activeGameData.msgtotalWIN
  ).toFixed(2);
  let totalLose = convertCreditsFromServerToClient(
    activeGameData.msgtotalLOSE
  ).toFixed(2);

  activeGameData.playerActivityMessageBox.setHeadText(
    activeGameData.gameTextGeneral.activeMessage +
      " " +
      activeGameData.playTimeHours +
      " " +
      activeGameData.gameTextGeneral.activeMessage2 +
      "."
  );
  activeGameData.playerActivityMessageBox.setBodyText(
    activeGameData.gameTextGeneral.bet +
      " : " +
      totalBet +
      activeGameData.currency +
      "\n" +
      activeGameData.gameTextGeneral.win +
      " : " +
      totalWin +
      activeGameData.currency +
      "\n" +
      activeGameData.gameTextGeneral.lose +
      " : " +
      totalLose +
      activeGameData.currency
  );
}

export function requestNewBalance(activeGameData: CommonData) {
  activeGameData.API_handler.GetBalance(
    activeGameData.balSuccessUpdate,
    activeGameData.betFail
  );
}

export function balSuccessCallBack(data: any, activeGameData: CommonData) {
  // activeGameData;
  // data;
  // console.log(data.creditsBalance.amount)
  let value = data.creditsBalance.amount;

  activeGameData.balance.updateValue(value);
  activeGameData.gameBar.setBalValue(activeGameData.balance.getDisplayValue());
  // console.log('REQUEST SUCCESS')
  checkUserBalToBet(activeGameData);
}
export function updateBalance(activeGameData: CommonData) {
  //-reset Value to zero

  if (activeGameData.freeSpinsActive == false) {
    // console.log("FINISHED and reset balance")
    if (activeGameData.updateBalanceOnRecovery) {
      activeGameData.balance.updateValue(
        activeGameData.betResponse.playerBalance.creditsBalance.amount
      );
      activeGameData.gameBar.setBalValue(
        activeGameData.balance.getDisplayValue()
      );
    }

    activeGameData.winValue.updateValue(0);
    activeGameData.gameBar.setWinValue(
      activeGameData.winValue.getDisplayValue()
    );
    //    console.log("bal +++++++++++++++++++++++++++++++ after" ,activeGameData.betResponse)
  }
  // console.log("bal after" ,activeGameData.betResponse)
  // console.log("bal after" ,activeGameData.balance.value)
}

export function updateWinBar(resetanim: boolean, activeGameData: CommonData) {
  //  console.log('wait')
  activeGameData.gameBar.setWinValue(activeGameData.winValue.getDisplayValue());

  // console.log(activeGameData)
  if (activeGameData.winValue.value > 0 && resetanim) {
    gameWaitWinlineAnimation(activeGameData);
  }
}

function gameWaitWinlineAnimation(activeGameData: CommonData) {
  if (activeGameData.mainGame.gameStartTicker.started === false) {
    enablePlay(false, activeGameData);

    let winlineWaitingTicker = new PIXI.ticker.Ticker();
    let timer = Date.now();
    let winlineDisplayLockDuration = 0;
    if (activeGameData.winLinesSwitchSpeed == undefined) {
      activeGameData.winLinesSwitchSpeed = 500;
    }
    if (activeGameData.mainGame.columns[0].skip === false) {
      winlineDisplayLockDuration =
        activeGameData.winLength * activeGameData.winLinesSwitchSpeed; //show all the winlines before letting play again on autoplay
    } else {
      winlineDisplayLockDuration = 500; //500//activeGameData.winLength*400+800;// while speedplaying ,lock for short time play btn
    }

    // console.log(winlineDisplayLockDuration,timer, activeGameData.winLength ,'start')
    winlineWaitingTicker.add(() => {
      if (Date.now() - timer > winlineDisplayLockDuration) {
        // console.log(activeGameData.isBonusMessageVisible)
        // console.log(activeGameData.playable)
        activeGameData.waitWinlines = false;
        if (activeGameData.isBonusMessageVisible === false) {
          enablePlay(true, activeGameData);
        }

        winlineWaitingTicker.stop();
        winlineWaitingTicker.destroy();
        winlineDisplayLockDuration = 0;
        // console.log("winlines")
        // console.log(winlineDisplayLockDuration,Date.now(), activeGameData.winLength ,'end')
      }
      if (activeGameData.skipAnimation) {
        winlineDisplayLockDuration = 0;
      }
      if (activeGameData.autoPlayTicker.started) {
        activeGameData.waitWinlines = true;
      } else {
        activeGameData.waitWinlines = false;
        winlineDisplayLockDuration = 100;
      }
    });

    winlineWaitingTicker.start();
  }
}

export function jackpotWinCheck(activeGameData: CommonData) {
  if (activeGameData.replay.isOpen() === false) {
    //jackpot is already defined inside replay so no need to check if in replay mode
    let bool = activeGameData.betResponse.hasOwnProperty("jackpotContext");
    if (bool) {
      //-disable
      if (activeGameData.BuyBonus != undefined) {
        // activeGameData.BuyBonusIsClientSideReady=false;
        activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);
        activeGameData.BuyBonus.setHidden(true);
      }
      // console.log('openJackpot');
      if (activeGameData.isEmulation) {
        //on emulation only display at the end
        // console.log('OPEN JACKPOT',activeGameData.betResponse.jackpotContext)
        if (
          activeGameData.betResponse.gameContext.contextData.finished &&
          activeGameData.betResponse?.jackpotContext?.jackpotSpinWin !=
            undefined
        ) {
          activeGameData.jackpotContext =
            activeGameData.betResponse.jackpotContext;

          startJackpot(activeGameData);
        }
      } else {
        //start jackpot on default games
        activeGameData.jackpotContext =
          activeGameData.betResponse.jackpotContext;

        startJackpot(activeGameData);
      }
    } else {
      activeGameData.jackpotContext = null;
    }
  }
}

export function enableGamble(bool: boolean, activeGameData: CommonData) {
  if (activeGameData.autoPlayTicker.started == false) {
    if (activeGameData.gambleGame.getGambleVisibility() === false) {
      displayGambleBtn(bool, activeGameData); //displayGambleBTN
    }
  } else {
    displayGambleBtn(false, activeGameData);
  }
}

export function setAllowedInputs(activeGameData: CommonData) {
  // console.log(activeGameData.betResponse.gameContext)

  enableGamble(false, activeGameData);
  enableBet(false, activeGameData);
  enableCollect(false, activeGameData);
  enableCtBonusSpin(false, activeGameData);
  activeGameData.gameBar.setAutoPlayBtn(false);
  let enableInputs =
    activeGameData.betResponse.gameContext.contextData.allowedInputActions;
  // console.log(enableInputs);

  if (jQuery.inArray("BET", enableInputs) >= 0) {
    // console.log("enableBet")
    enableBet(true, activeGameData);
    // console.log("enableBet")
  }
  if (jQuery.inArray("GAMBLE", enableInputs) >= 0) {
    enableGamble(true, activeGameData);
    //  console.log("GAMBLE ENABLED")
  }

  if (jQuery.inArray("COLLECT", enableInputs) >= 0) {
    if (activeGameData.gameType == activeGameData.gameTypesList[0]) {
      enableCollect(true, activeGameData);
    }
  }
  if (jQuery.inArray("BONUSSPIN", enableInputs) >= 0) {
    enableCtBonusSpin(true, activeGameData);
  }
  //--pandora box only
  if (jQuery.inArray("BONUS_SPIN", enableInputs) >= 0) {
    enableCtBonusSpin(true, activeGameData);
  }

  if (jQuery.inArray("WALKING_BONUS_SPIN", enableInputs) >= 0) {
    enableWildFairiesBonusSpin(true, activeGameData, 0);
  }

  if (jQuery.inArray("EXPAND_WILDS", enableInputs) >= 0) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionExpandWild();
  }

  if (jQuery.inArray("STICKY_BONUS_SPIN", enableInputs) >= 0) {
    enableWildFairiesBonusSpin(true, activeGameData, 1);
  }

  if (jQuery.inArray("EXPANDING_BONUS_SPIN", enableInputs) >= 0) {
    enableWildFairiesBonusSpin(true, activeGameData, 2);
  }

  //-- stardiceDeluxe and Pandoras Box
  if (jQuery.inArray("SWITCH_STAKE", enableInputs) >= 0) {
    enableBet(true, activeGameData);
  }

  //-- Winline
  if (jQuery.inArray("RESPIN", enableInputs) >= 0) {
    changePlayBtnTo(0, activeGameData);
  }

  //-- Winline
  if (jQuery.inArray("PICK_DOOR", enableInputs) >= 0) {
    // changePlayBtnTo(0, activeGameData);
    activeGameData.serverAction = "PICK_DOOR";
  }
  //---
  //disable  changing bet while in freespin game
  if (activeGameData.freeSpinsCount > 0) {
    enableBet(false, activeGameData);
  }
  //--
  if (
    activeGameData.BuyBonus != undefined &&
    activeGameData.API_handler.getServerActionBUY_BONUS != undefined
  ) {
    if (
      jQuery.inArray(
        activeGameData.API_handler.getServerActionBUY_BONUS(),
        enableInputs
      ) >= 0
    ) {
      // changePlayBtnTo(0, activeGameData);
      // activeGameData.serverAction="PICK_DOOR"

      activeGameData.BuyBonus.enableBuyBonusIfAllowed(true);
    } else {
      activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);
    }
  }

  //--
  activeGameData.gameBar.setAutoPlayBtn(true);

  replayCheck(activeGameData);
}

export function replayCheck(activeGameData: CommonData) {
  // console.log("TES UI")
  if (activeGameData.replayMode) {
    closeOptionWindow(activeGameData);
    activeGameData.gameBar.setGambleBtnsButtonMode(false); //disable gamble btn
    stopAutoPlay(activeGameData);
    // enableGamble(false, activeGameData);
    enableBet(false, activeGameData);
    enableCollect(false, activeGameData);
    enableCtBonusSpin(false, activeGameData);

    activeGameData.gameBar.setButtonMode(false);
    activeGameData.jackPotGame.setCountersButtonVisible(false);
  }
}

export function jackpotWinOnNonWinningGameSpin(activeGameData: CommonData) {
  let jw =
    activeGameData.betResponse?.jackpotContext?.jackpotSpinWin?.credits?.amount;
  // console.log('jackpotWin:',jw!=undefined?jw:'doesnt exist');
  // console.log('playerBal:',activeGameData.betResponse.playerBalance.creditsBalance.amount,'stake:',activeGameData.betSelected.getServerVal());
  if (jw != undefined && !activeGameData.replayMode) {
    //player won Jackpot  now Substract from the gameresponse because it will be updated on the balance reuest when jackpopt closes
    activeGameData.betResponse.playerBalance.creditsBalance.amount -= jw;
    updateBalance(activeGameData);
  }
  jackpotWinCheck(activeGameData);
}

export function displayeGambleGame(bool: boolean, activeGameData: CommonData) {
  activeGameData.gambleGame.startGamble(bool);
  if (bool == false) {
    checkUserBalToBet(activeGameData);
  }
}

export function pauzeAutoPlayOnOrientationChange(activeGameData: CommonData) {
  if (activeGameData.playOnPortrait == false) {
    //make sure that ticker and autoplay count are both defined and is mobile
    if (
      activeGameData != undefined &&
      activeGameData.autoCountListselected != undefined &&
      activeGameData.autoPlayTicker != undefined &&
      activeGameData.isMobile
    ) {
      let isPortraitMode = window.matchMedia("(orientation: portrait)").matches;

      // then call the function autoplayPauze
      if (isPortraitMode) {
        autoPlayPauze(true, activeGameData);
      } else {
        autoPlayPauze(false, activeGameData);
      }
      // console.log('noproblem')
    }
  }
}

export function autoPlayPauze(bool: boolean, activeGameData: CommonData) {
  if (activeGameData.autoPlayTicker.started) {
    if (bool) {
      activeGameData.autoPlayTicker.stop();
    }
  } else {
    if (activeGameData.autoCountListselected > 0 && bool == false) {
      activeGameData.autoPlayTicker.start();
    }
  }
}

// export function MessageScaleOnPortrait(isMobile:boolean,containerToScale:PIXI.Container,size:Array<number>)
// {

//     if (window.matchMedia("(orientation: portrait)").matches &&isMobile) {

//         let newScale=1.9;
//         // newScale=1
//         // console.log(newScale)
//         containerToScale.scale.set(newScale);

//         // let scaleMult=(1/2);
//         containerToScale.x=-((size[0]*newScale)-size[0])/2;
//         containerToScale.y=-((size[1]*newScale)-size[1])/2+40;
//         // console.log('PM',newScale)

//      }
//      else
//      {
//         // console.log('LM')
//         containerToScale.scale.set(1);
//         containerToScale.x=0;
//         containerToScale.y=0;
//      }

// }

export function doubleScaleOnPortrait(
  isMobile: boolean,
  containerToScale: PIXI.Container,
  size: Array<number>,
  maxScale: number
) {
  if (window.matchMedia("(orientation: portrait)").matches && isMobile) {
    let newScale = maxScale;
    // newScale=1

    // console.log(newScale)
    containerToScale.scale.set(newScale);

    // let scaleMult=(1/2);
    containerToScale.x = -(size[0] * newScale - size[0]) / 2;
    containerToScale.y = -(size[1] * newScale - size[1]) / 2 + 40;
    // console.log('PM',newScale)
  } else {
    // console.log('LM')
    containerToScale.scale.set(1);
    containerToScale.x = 0;
    containerToScale.y = 0;
  }
}

export function shuffleArray(array: Array<any>) {
  // let array=[0,1,2,3,4,5];
  //random permutation

  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  // console.log(array)
  return array;
}

export function getAllIndexes(arr: Array<any>, val: any) {
  var indexes = [],
    i = -1;
  while ((i = arr.indexOf(val, i + 1)) != -1) {
    indexes.push(i);
  }
  return indexes;
}

//
export function autoCaptilizeFirstLetterOnly(stringToEdit: string) {
  stringToEdit = stringToEdit.toLocaleLowerCase();
  const arr = stringToEdit.split(" ");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const str2 = arr.join(" ");
  return str2;
}

export function abbreviateNumber(value: number) {
  var newValue: string = value + "";
  if (value >= 1000) {
    var suffixes = ["", "k", "m", "b", "t", "q"]; //,"Q","s","S","o","n","d","U","D","T","Qt","Qd","Sd","O","N","v","c"];
    var suffixNum = Math.floor(("" + value).length / 3);
    var shortValue: any = "";
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum != 0
          ? value / Math.pow(1000, suffixNum)
          : value
        ).toPrecision(precision)
      );
      var dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  } else {
    //add 2 decimals
    var hasDecimal = value % 1 !== 0;
    if (hasDecimal) {
      newValue = value.toFixed(2);
    }
  }
  return newValue;
}

export function abbreviateStringNumber(value: string) {
  var newValue: string = value;
  if (parseInt(value) >= 1000) {
    var suffixes = ["", "k", "m", "b", "t", "q"]; //,"Q","s","S","o","n","d","U","D","T","Qt","Qd","Sd","O","N","v","c"];
    var suffixNum = Math.floor(value.length / 3);
    var shortValue: any = "";
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat(
        (suffixNum != 0
          ? parseInt(value) / Math.pow(1000, suffixNum)
          : parseInt(value)
        ).toPrecision(precision)
      );
      var dotLessShortValue = (shortValue + "").replace(/[^a-zA-Z 0-9]+/g, "");
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
}

export function splitTextWithDash(input: string): [string, string] {
  const [output1, output2] = input.split("-");
  return [output1, output2];
}

export function skipGame(activeGameData: CommonData) {
  if (
    activeGameData.skipAnimation === false &&
    activeGameData.infiniteSpin === false &&
    activeGameData.commonConfigData.isSkipAvailable
  ) {
    //ONLT FOR SLOT GAME,  NO NEED SKIP FOR DICE GAME
    enablePlay(false, activeGameData);
    activeGameData.skipAnimation = true;
  }
}

// Function to check if a value is null or undefined
export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

interface versionFile {
  version: number;
}
export async function setVersionFromFile(
  activeGameData: CommonData,
  callbackFn: Function
) {
  const USE_URL_VERSION = true;

  if (USE_URL_VERSION) {
    let urlVersion = getParameterByName("version");
    activeGameData.gameVersion = urlVersion.toString();

    const singleton = GameVersion.getInstance();
    singleton.version = urlVersion.toString();
    callbackFn();
  } else {
    const fileUrl = "version.json?v=" + Date.now();
    try {
      const response = await axios.get(fileUrl);
      const jsonData: versionFile = response.data;

      const versionNumber = jsonData.version;
      activeGameData.gameVersion = versionNumber.toString();

      const singleton = GameVersion.getInstance();
      singleton.version = versionNumber.toString();

      callbackFn();
    } catch (error) {
      console.error("Error:", error);
    }
  }
}
